<template>
  <div class="login">
    <el-form
      :model="loginForm"
      :rules="loginRules"
      ref="loginForm"
      label-width="100px"
      class="demo-loginForm"
    >
      <el-form-item label="用户名" prop="name">
        <el-input
          type="text"
          v-model="loginForm.name"
          auto-complete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="pass">
        <el-input
          type="password"
          v-model="loginForm.pass"
          auto-complete="off"
          @keyup.enter.native="loginSubmit"
        ></el-input>
      </el-form-item>

      <el-form-item label="服务域名" v-if="isDev">
        <el-autocomplete
          v-model="domain"
          :fetch-suggestions="querySearch"
          placeholder="请输入服务域名地址"
          :select-when-unmatched="true"
          style="width: 100%"
        ></el-autocomplete>
      </el-form-item>

      <el-form-item class="loginBtn">
        <el-button type="primary" @click.stop.prevent="loginSubmit"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <div id="captchaBox"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "../../assets/gt.js";
import JSEncrypt from "jsencrypt";

export default {
  data() {
    let checkUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (value.length < 6 || value.length > 20) {
          callback(new Error("密码格式错误"));
        } else {
          callback();
        }
      }
    };
    return {
      flag: true,
      user: {},
      isDev: this.$util.isDev, ////////////////////////////////////////////////  线上：false, 开发：true
      domain: "",
      uuid: "",
      host: [
        { value: "api_185" },
        { value: "http://test.adminapi.gxapp.iydsj.com/adminapi" },
        { value: "http://pre.adminapi.gxapp.iydsj.com/adminapi" },
        { value: "http://192.168.0.126:18083" },
        { value: "https://admin.gxapp.iydsj.com/background" },
      ],
      loginForm: {
        name: "",
        pass: "",
        userId: 1,
      },
      loginRules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            validator: checkUsername,
          },
        ],
        pass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: validatePass,
          },
        ],
      },
    };
  },
  mounted() {
    this.$util.removeStore("domain");
    this.SIGNOUT();
  },
  methods: {
    ...mapActions(["SIGNIN", "SIGNOUT"]),

    loginSubmit(ev) {
      if (this.flag) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.flag = false;
            this.changeDomain();
            // 请求验证
            this.uuid = this.$util.createUuid();
            this.firstVerification();
          } else {
            return false;
          }
        });
      } else {
        return;
      }
    },
    // 登录请求
    loginSubmitHttp() {
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(this.$util.rsaPublicKey);
      const encryptedPassword = encryptor.encrypt(this.loginForm.pass);

      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/user/login",
        credentials: true,
        body: JSON.stringify({
          username: this.loginForm.name,
          password: encryptedPassword, //this.loginForm.pass,
          uuid: this.uuid,
        }),
      }).then(
        (response) => {
          if (response.data.error === 10000) {
            this.user = {
              userId: response.data.data.userid,
              name: response.data.data.name,
              authWriteList: response.data.data.authWriteList,
            };
            this.SIGNIN(this.user);
            // //判断版本变量
            location.href = this.$util.isComplexVersion
              ? "/#/index"
              : "/#/userM/allUser";
            // location.reload();
            // location.reload();
            // history.replaceState(null, null, '/#/index');
          } else {
            this.$util.errorMsg(response.data.message, "错误");
            this.flag = true;
          }
        },
        (response) => {
          this.flag = true;
        }
      );
    },

    // 初始化极验
    firstVerification() {
      let that = this;

      this.$http({
        method: "GET",
        url:
          this.$util.domain +
          "/geeTest/preProcess?uuid=" +
          this.uuid +
          "&username=" +
          this.loginForm.name,
        dataType: "json",
      })
        .then((response) => {
          if (response.data.error == 10000) {
            // 初始化极验
            initGeetest(
              {
                gt: response.data.data.gt,
                challenge: response.data.data.challenge,
                offline: !response.data.data.success,
                product: "bind",
                // https: true,
                new_captcha: true,
              },
              function (captchaObj) {
                captchaObj.appendTo("#captchaBox");
                // 这里可以调用验证实例 captchaObj 的实例方法
                captchaObj
                  .onReady(function () {
                    captchaObj.verify();
                    that.flag = true;
                  })
                  .onSuccess(function () {
                    let result = captchaObj.getValidate();
                    // 二次请求验证结果
                    that.secondVerification(result);
                  })
                  .onError(function () {
                    //your code
                    that.$util.errorMsg("验证失败，请重试！");
                  });
              }
            );
          } else {
            that.flag = true;
            that.$util.errorMsg("验证失败，请重试！");
          }
        })
        .catch((_) => {
          that.flag = true;
        });
    },

    // 极验二次验证
    secondVerification(params) {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/geeTest/validate",
        dataType: "json",
        body: JSON.stringify({
          username: this.loginForm.name,
          uuid: this.uuid,
          challenge: params.geetest_challenge,
          validate: params.geetest_validate,
          seccode: params.geetest_seccode,
        }),
      })
        .then((response) => {
          if (response.data.error == 10000) {
            // 发送登录请求
            this.loginSubmitHttp();
          } else {
            this.$util.errorMsg("验证失败，请重试！");
          }
        })
        .catch((_) => {
          this.$util.errorMsg("验证失败，请重试！");
        });
    },

    //切换请求域名地址
    changeDomain() {
      if (this.domain) {
        this.$util.setStore("domain", this.domain);
        this.$util.domain = this.$util.getStore("domain");
      }
    },
    querySearch(queryString, cb) {
      let restaurants = this.host;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
  },
};
</script>
<style>
.login .el-form {
  position: absolute;
  top: 150px;
  left: 50%;
  width: 500px;
  margin-left: -280px;
}

.login .el-button {
  margin-left: 170px;
}
</style>



// WEBPACK FOOTER //
// login.vue?085dec18